import { ZenitList } from '../models/zenit-general.model';

import { EventFrom } from '@shared/analytics/COMMON/models/analytics-common.models';

export interface ZenitAnalyticsState {
    originItemEventFrom: EventFrom;
    originItemListIndex: number;
    originItemListName: ZenitList;
    originItemRelatedType: EventFrom;
}

export const zenitInitialState: ZenitAnalyticsState = {
    originItemEventFrom: undefined,
    originItemListIndex: undefined,
    originItemListName: undefined,
    originItemRelatedType: undefined,
};
